(function () {
  let sliderInitialized = false;

  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  const initializeBlock = (block, attributes = null) => {
    block.querySelectorAll('.team__member-button').forEach((button) => {
      let swiper;

      button.addEventListener('click', () => {
        if (!sliderInitialized) {
          swiper = initializeSlider(block);
        }

        swiper.slideTo(button.dataset.index, 0);
        showOverlay(block);
      });
    });

    block.querySelectorAll('.team__slide-close-button').forEach((button) => {
      button.addEventListener('click', () => {
        hideOverlay(block);
      });
    });

    block.querySelector('.team__overlay').addEventListener('click', (e) => {
      if (
        e.target.classList.contains('team__overlay') ||
        e.target.classList.contains('swiper-container') ||
        e.target.classList.contains('swiper-wrapper') ||
        e.target.classList.contains('swiper-slide')
      ) {
        hideOverlay(block);
      }
    });

    window.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        hideOverlay(block);
      }
    });
  };

  const initializeSlider = (block) => {
    return new Swiper(block.querySelector('.team__slider'), {
      speed: 400,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.team__slider-nav-button--next',
        prevEl: '.team__slider-nav-button--prev',
        disabledClass: 'team__slider-nav-button--disabled',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 3,
    });
  };

  const getOverlay = (block) => {
    return block.querySelector('.team__overlay');
  };

  const showOverlay = (block) => {
    block.classList.add('team--overlay-visible');
    getOverlay(block).classList.add('team__overlay--visible');
  };

  const hideOverlay = (block) => {
    block.classList.remove('team--overlay-visible');
    getOverlay(block).classList.remove('team__overlay--visible');
  };

  // Initialize each block on page load (front end)
  document.querySelectorAll('.team').forEach((block) => {
    initializeBlock(block);
  });

  window.addEventListener('init', () => {
    document.querySelectorAll('.team').forEach((block) => {
      initializeBlock(block);
    });
  });

  // Initialize the dynamic block preview (editor)
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=team', ($block, attributes) => {
      initializeBlock($block.find('.team').get(0), attributes);
    });
  }
})();